import { EventTracking, EventType } from '@app/tracking';
var GoogleAnalyticsUniversal = /** @class */ (function () {
    function GoogleAnalyticsUniversal(scriptPath, propertyId, anonymizeIp) {
        this.propertyId = propertyId;
        // Setup script tag
        var scriptTag = document.createElement('script');
        scriptTag.async = true;
        scriptTag.src = scriptPath;
        document.body.appendChild(scriptTag);
        // Setup data layer
        window.ga = window.ga || function () {
            (ga.q = ga.q || []).push(arguments);
        };
        ga.l = +new Date;
        // Initialize
        ga('set', 'anonymizeIp', anonymizeIp);
        ga('create', propertyId, 'auto');
        if (window.laravelDebug) {
            console.log("\u2705 Google Universal Tracking initialized for \"" + propertyId + "\"");
        }
        this.registerListeners();
    }
    GoogleAnalyticsUniversal.prototype.registerListeners = function () {
        var _this = this;
        // Page view
        EventTracking.listen(EventType.PageView, function (_a) {
            var title = _a.title, path = _a.path;
            ga('send', {
                hitType: 'pageview',
                page: path,
                title: title
            });
        });
        // Form submit
        EventTracking.listen(EventType.FormSubmit, function (_a) {
            var form = _a.form;
            _this.sendEvent('ContactForm', 'submit', form);
        });
        // Form success
        EventTracking.listen(EventType.FormSuccess, function (_a) {
            var form = _a.form;
            _this.sendEvent('ContactForm', 'success', form);
        });
        // Form error
        EventTracking.listen(EventType.FormError, function (_a) {
            var form = _a.form, error = _a.error;
            _this.sendEvent('ContactForm', 'error', form, error);
        });
        // Locator search
        EventTracking.listen(EventType.LocatorSearch, function (_a) {
            var searchQuery = _a.searchQuery;
            _this.sendEvent('Location', 'Search', searchQuery);
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceAddItem, function (event) {
            _this.sendEvent('Shop', 'AddToCart', event.sku, event.price);
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceRemoveItem, function (event) {
            _this.sendEvent('Shop', 'RemoveFromCart', event.sku, event.price);
        });
        // Shop Go to Checkout
        EventTracking.listen(EventType.EcommerceCheckout, function (event) {
            _this.sendEvent('Shop', 'Checkout', event.id, event.total);
        });
        // Custom events
        EventTracking.listen(EventType.Track, function (_a) {
            var category = _a.category, action = _a.action, label = _a.label, _b = _a.value, value = _b === void 0 ? '' : _b;
            _this.sendEvent(category, action, label, value);
        });
    };
    GoogleAnalyticsUniversal.prototype.sendEvent = function (category, action, label, value) {
        if (value === void 0) { value = null; }
        ga('send', 'event', category, action, label, value);
    };
    return GoogleAnalyticsUniversal;
}());
export default GoogleAnalyticsUniversal;
